import React, { useState } from "react";
import { useRouter } from "next/router";
import { useDetectClickOutside } from "react-detect-click-outside";
import { Icon } from "../../icons/icons";
import CustomerItem from "../Detail/CustomerItem";
import { useTranslation } from "../../context/TranslationContext";
const FormCustomer = ({ setParam, isMobile = false }) => {
  const { customer, adult, child, childAge, infant, infantAge } =
    useTranslation();
  const router = useRouter();

  const [yetiskin, setYetiskin] = useState(router.query.yetiskin || 1);
  const [cocuk, setCocuk] = useState(router.query.cocuk || 0);
  const [bebek, setBebek] = useState(router.query.bebek || 0);

  const [isOpen, setIsOpen] = useState(false);
  const CloseToggle = () => {
    setIsOpen(0);
  };
  const ref = useDetectClickOutside({ onTriggered: CloseToggle });

  return (
    <div className="bg-white flex flex-col relative" ref={ref}>
      <div
        className="flex items-center lg:py-5 lg:pl-8 lg:pr-7 cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <div className="flex justify-between flex-1">
          <div className="flex flex-wrap">
            <span className="font-bold text-brand-gray-2 text-13 w-full">
              {customer}
            </span>
            <span className="font-bold text-xl mr-8">
              {yetiskin}
              <span className="text-xs -top-0.5 relative inline-block ml-1.5">
                {adult}
              </span>
            </span>
            <span className="font-bold text-xl">
              {cocuk}
              <span className="text-xs -top-0.5 relative inline-block ml-1.5">
                {child}
              </span>
            </span>
          </div>
        </div>
        <div className="mt-5">
          <Icon name={"ArrowDown"}></Icon>
        </div>
      </div>
      <div
        className={`flex z-10 bg-white flex-col py-5 lg:px-7 top-full absolute w-full origin-top transition-transform transform-gpu ${
          isOpen ? "scale-y-100 " : "scale-y-0 "
        }`}
      >
        <CustomerItem
          title={adult}
          onchange={(e) => {
            setYetiskin(e);
            const a = {};
            a.yetiskin = e;
            setParam(a);
          }}
          defaultValue={yetiskin}
          min={1}
        ></CustomerItem>
        <CustomerItem
          title={child}
          subTitle={childAge}
          onchange={(e) => {
            setCocuk(e);
            const a = {};
            a.cocuk = e;
            setParam(a);
          }}
          max={2}
          defaultValue={cocuk}
        ></CustomerItem>

        <CustomerItem
          title={infant}
          subTitle={infantAge}
          onchange={(e) => {
            setBebek(e);
            const a = {};
            a.bebek = e;
            setParam(a);
          }}
          max={2}
          defaultValue={bebek}
        ></CustomerItem>
      </div>
    </div>
  );
};

export default FormCustomer;
